// Lightweight Supabase client factory
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let client = null;

export function getSupabaseClient() {
	if (client) return client;
	if (!supabaseUrl || !supabaseAnonKey) {
		return null;
	}
	client = createClient(supabaseUrl, supabaseAnonKey, {
		autoRefreshToken: true,
		persistSession: true,
		retry: { attempts: 2 }
	});
	return client;
}

export function isSupabaseConfigured() {
	return Boolean(supabaseUrl && supabaseAnonKey);
}


